import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Every route component is React.lazy. Without this flag the router commits location
// changes on React's sync lane, so a click on a not-yet-downloaded route throws
// "A component suspended while responding to synchronous input" and takes the app down.
// The router funnels Link clicks, navigate(), <Navigate> and back/forward through a
// single history listener, so this one flag covers all of them.
const routerFuture = { v7_startTransition: true };

root.render(
    <BrowserRouter future={routerFuture}>
      <App />
    </BrowserRouter>
);
